import { Country } from '@shared/domain/country/country.aggregate';

export interface CountryDto {
  id: number;
  name: string;
  code: string;
}

export const toCountryDomainEntity = (
  incommingCountry: CountryDto
): Country => {
  return {
    id: incommingCountry.id,
    code: incommingCountry.code,
    name: incommingCountry.name
  };
};
